import React, { useState } from "react";

function EventMessageModal({ vendor, eventName, onClose, onSend }) {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:16,maxWidth:480,width:'100%',overflow:'hidden'}}>
        <div style={{background:'#1a1410',padding:'20px 24px'}}>
          <div style={{fontSize:14,color:'#a89a8a'}}>Message Vendor</div>
          <div style={{fontSize:20,fontWeight:700,color:'#e8c97a',fontFamily:'Playfair Display,serif'}}>{vendor?.name}</div>
          {eventName && <div style={{fontSize:13,color:'#c8a850',marginTop:4}}>{'\ud83d\udccb'} Regarding: {eventName}</div>}
        </div>
        <div style={{padding:'24px'}}>
          <div className="form-group" style={{marginBottom:16}}>
            <label>Your Message *</label>
            <textarea value={message} onChange={e=>setMessage(e.target.value)} rows={4} placeholder="Introduce yourself, ask about availability, discuss event details..." style={{width:'100%',border:'1.5px solid #e0d5c5',borderRadius:8,padding:'10px 14px',fontSize:14,fontFamily:'DM Sans,sans-serif',resize:'vertical',outline:'none',boxSizing:'border-box'}} />
          </div>
          <div style={{fontSize:11,color:'#a89a8a',marginBottom:16,lineHeight:1.5}}>
            Vendor contact info is not shared through messaging. Contact details are only revealed after an accepted booking on a posted event.
          </div>
          <div style={{display:'flex',gap:10}}>
            <button disabled={!message.trim()||sending} onClick={async()=>{setSending(true);await onSend(message.trim());setSending(false);}} style={{flex:2,background:message.trim()?'#1a1410':'#e8ddd0',color:message.trim()?'#e8c97a':'#a89a8a',border:'none',borderRadius:8,padding:'12px 0',fontSize:14,fontWeight:700,cursor:message.trim()?'pointer':'default',fontFamily:'DM Sans,sans-serif'}}>{sending?'Sending...':'Send Message'}</button>
            <button onClick={onClose} style={{flex:1,background:'#f5f0ea',color:'#1a1410',border:'1px solid #e0d5c5',borderRadius:8,padding:'12px 0',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventMessageModal;
